// extracted by mini-css-extract-plugin
export default {"password":"PasswordDetail_password__lXWxJ","detail":"PasswordDetail_detail__2vddx"};